import {faChevronLeft, faChevronRight} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FunctionComponent} from 'react';
import {FlatListState} from './FlatListState';

export interface FlatsListPaginatorProps {
    state: FlatListState;
}

function getPagingRange(current: number, {min = 1, total = 1, length = 1} = {}) {
    if (length > total) {
        length = total;
    }

    let start = current - Math.floor(length / 2);
    start = Math.max(start, min);
    start = Math.min(start, min + total - length);

    return Array.from({length: length}, (el, i) => start + i);
}

export const FlatsListPaginatorComponent: FunctionComponent<FlatsListPaginatorProps> = observer(({state}) => (
    <React.Fragment>
        {state.log !== undefined && <ul className="bg-m-gray-2 inline-flex items-center p-px rounded-md font-normal font-roboto-regular">
            <li className="inline-block px-1 py-px">
                <button
                    className="btn btn-sm"
                    onClick={() => state.changePage((state.log?.page ?? 1) - 1)}
                    disabled={state.log?.page === 1}
                >
                    <FontAwesomeIcon icon={faChevronLeft}/>
                </button>
            </li>
            {(state.log.page ?? 0) - 10 > 2 && (
                <React.Fragment>
                    <li className={'inline-block mx-px px-1 py-px'}>
                        <button onClick={() => state.changePage(1)}>1</button>
                    </li>
                    <li className={'inline-block mx-px px-1 py-px'}>...</li>
                </React.Fragment>
            )}

            {getPagingRange(state.log.page ?? 1, {min: 1, total: state.log.totalPages, length: 10}).map((p) => (
                <li key={'page' + p + state.log?.logId} className="inline-block mx-px px-1 py-px">
                    <button
                        className={p === state.log?.page ? 'btn btn-sm btn-primary w-10' : 'btn btn-sm'}
                        onClick={() => state.changePage(p)}
                    >
                        {p}
                    </button>
                </li>
            ))}

            {state.log && ((state.log.page ?? 0) + 10 < (state.log.totalPages ?? 0)) && (
                <React.Fragment>
                    <li className={'inline-block mx-px px-1 py-px'}>...</li>
                    <li className={'inline-block mx-px px-1 py-px'}>
                        <button onClick={() => state.changePage(state.log!.totalPages!)}>
                            {state.log.totalPages}
                        </button>
                    </li>
                </React.Fragment>
            )}

            <li className="inline-block px-1 py-px">
                <button
                    className="btn btn-sm"
                    onClick={() => state.changePage((state.log?.page ?? 1) + 1)}
                    disabled={state.log.page === state.log.totalPages}
                >
                    <FontAwesomeIcon icon={faChevronRight}/>
                </button>
            </li>
        </ul>}
    </React.Fragment>
));
